import { Dispatch, createContext } from "react";

import { AuthTransaction } from "../types/authTransaction";
import { ParsedFactorData } from "../types/parsedTransactionFactorData";

type AuthTransactionContextType = {
  isTransactionExpired: boolean;
  isFetchingTransaction: boolean;
  transaction?: AuthTransaction;
  setTransaction: Dispatch<AuthTransaction>;
  setIsTransactionExpired: Dispatch<boolean>;
  completeRegistration: (authorizationUrl: string) => void;

  // The transaction response for statuses, MFA_ENROLL and MFA_ENROLL_ACTIVATE, is inconsistent and will cycle between including the full factor list and the current factor being enrolled
  // This factorData property will be used as the source of truth for all current factor data
  // The full list of factors will be saved to storage and used as the default on page load
  // Any transaction response that includes a factor list will replace the current one in this object and in storage
  factorData: ParsedFactorData;
  setFactorData: Dispatch<ParsedFactorData>;
};

const AuthTransactionContext = createContext<AuthTransactionContextType>({
  isTransactionExpired: false,
  isFetchingTransaction: false,
  transaction: undefined,
  setTransaction: () => undefined,
  setIsTransactionExpired: () => undefined,
  completeRegistration: () => undefined,
  setFactorData: () => undefined,
  factorData: {
    factorMap: {},
    factorOrder: [],
  },
});

export default AuthTransactionContext;
